<template>
    <div class="aptitudFisica-form">
        <div class="form-header">
            <h3 class="form-title">
                <i class="fa-solid fa-dumbbell text-success"></i>
                Examen Aptitud Física
            </h3>
            <b-button variant="primary" size="sm" @click="collapsed = !collapsed" class="toggle-btn">
                <i :class="collapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"></i>
            </b-button>
        </div>

        <b-collapse v-model="collapsed" class="mt-3">
            <b-card class="shadow-sm border-0 bg-dark">
                <b-form @submit.prevent="registrarExamenAptitudFisica" novalidate>
                    <!-- Información del conductor -->
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Tipo de documento del conductor" label-for="tipo-documento"
                                label-class="form-label-custom">
                                <v-select id="tipo-documento" v-model="form.tipoIdentificacion"
                                    :options="tipoIdentificaciones" :reduce="option => option.codigo"
                                    :get-option-label="option => option.descripcion"
                                    placeholder="-- Selecciona tipo documento --" class="v-select-custom">
                                    <template #search="{ attributes, events }">
                                        <input class="vs__search" :required="!form.tipoIdentificacion"
                                            v-bind="attributes" v-on="events" />
                                    </template>
                                    <template #no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se encontraron resultados para
                                            <em class="text-danger">{{ search }}</em>
                                        </template>
                                        <em v-else class="text-muted">No hay datos para mostrar</em>
                                    </template>
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Número de documento del conductor" label-for="numero-documento"
                                label-class="form-label-custom" :invalidFeedback="mensajesError.numeroIdentificacion">
                                <b-form-input id="numero-documento" v-model="form.numeroIdentificacion" type="number" min="0" max="12"
                                    placeholder="Ej: 123456789" required class="" :state="estadosCampos.numeroIdentificacion" @input="validarNumero(12, 'numeroIdentificacion')" />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Fecha y hora del examen -->
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                            <b-form-group label="Fecha de examen" label-for="fecha-examen"
                                label-class="form-label-custom">
                                <b-form-input id="fecha-examen" v-model="form.fechaExamen" type="date" required
                                    class="" />
                                <small v-if="fechaExamenFormateada" class="text-muted mt-1 d-block">
                                    Fecha seleccionada: {{ fechaExamenFormateada }}
                                </small>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group label="Hora de examen" label-for="hora-examen"
                                label-class="form-label-custom">
                                <b-form-input id="hora-examen" v-model="form.horaExamen" type="time" required
                                    class="" />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Resultado -->
                    <b-row class="mb-4">
                        <b-col cols="12" lg="6">
                                <b-form-group label="Resultado" label-for="resultado" label-class="form-label-custom">
                                    <v-select id="tipo-documento" v-model="form.resultado" :options="tipoResultado"
                                        placeholder="-- Resultado de la prueba --" class="v-select-custom">
                                        <template #search="{ attributes, events }">
                                            <input class="vs__search" :required="!form.resultado" v-bind="attributes"
                                                v-on="events" />
                                        </template>
                                        <template #no-options="{ search, searching }">
                                            <template v-if="searching">
                                                No se encontraron resultados para
                                                <em class="text-danger">{{ search }}</em>
                                            </template>
                                            <em v-else class="text-muted">No hay datos para mostrar</em>
                                        </template>
                                    </v-select>
                                </b-form-group>
                        </b-col>
                    </b-row>

                    <!-- Botón de envío -->
                    <div class="d-flex justify-content-end pt-3">
                        <b-button type="submit" variant="primary" size="lg" :disabled="loading" class="btn-submit">
                            <b-spinner v-if="loading" small class="mr-2"></b-spinner>
                            <i v-else class="fa-solid fa-floppy-disk mr-2"></i>
                            {{ loading ? 'Guardando...' : 'Guardar Examen' }}
                        </b-button>
                    </div>
                </b-form>
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
import { validarCampoTexto } from '../../../../../assets/js/validations/validarCampoTexto';
export default {
    name: 'FormularioaptitudFisica',
    props: {
        tipoIdentificaciones: {
            type: Array,
            default: () => []
        },
        resultsExams: {
            type: Array,
            default: () => []
        },
        preCarga: {
            type: Object,
            default: null

        }
    },
    data() {
        return {
            collapsed: true,
            loading: false,
            form: {
                tipoIdentificacion: null,
                numeroIdentificacion: '',
                fechaExamen: '',
                horaExamen: '',
                resultado: null,
            },
            tipoResultado: [
                'Apto',
                'No Apto'
            ],
            estadosCampos: {
                numeroIdentificacion: null,
            },
            mensajesError: {
                numeroIdentificacion: '',
            }
        }
    },
    computed: {
        fechaExamenFormateada() {
            if (!this.form.fechaExamen) return '';
            const [yyyy, mm, dd] = this.form.fechaExamen.split('-');
            return `${dd}/${mm}/${yyyy}`;
        }
    },
    methods: {
        async registrarExamenAptitudFisica() {
            this.loading = true;

            const data = {
                tipoIdentificacion: this.form.tipoIdentificacion,
                numeroIdentificacion: this.form.numeroIdentificacion,
                fechaExamen: this.fechaExamenFormateada,
                horaExamen: this.form.horaExamen,
                resultado: this.form.resultado,
            };

            this.$emit('submit', data);
            this.loading = false;
        },

        resetForm() {
            this.form = {
                tipoIdentificacion: null,
                numeroIdentificacion: '',
                fechaExamen: '',
                horaExamen: '',
                resultado: null,
            };
        },
        parseFecha(fecha) {
            if (!fecha) return '';
            const date = new Date(fecha);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        validarNumero(max, campo) {
            validarCampoTexto({
                objeto: this.form,
                campo: campo,
                max: max,
                soloNumeros: true,
                estados: this.estadosCampos,
                mensajes: this.mensajesError
            })
        }
    },
    watch: {
        preCarga: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form = {
                        tipoIdentificacion: val.tipoIdentificacion ?? null,
                        numeroIdentificacion: val.numeroIdentificacion ?? '',
                        fechaExamen: this.parseFecha(val.fechaExamen),
                        horaExamen: val.horaExamen ?? '',
                        resultado: val.resultado ?? null
                    };
                }
            }
        }
    }

}
</script>

<style scoped>
.aptitudFisica-form {
    margin-bottom: 2rem;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-radius: 0.5rem;
    border-left: 4px solid #28a745;
    box-shadow: 0 2px 6px rgba(75, 72, 72, 0.37);
}

.form-title {
    margin: 0;
    font-weight: 600;
    font-size: 1.25rem;
}

.toggle-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.form-label-custom {
    font-weight: 600;
    margin-bottom: 0.5rem;
}



.v-select-custom {
    border-radius: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle {
    border: 2px solid #e9ecef;
    border-radius: 0.5rem;
    padding: 0.5rem;
}

.v-select-custom .vs__dropdown-toggle:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-submit {
    padding: 0.75rem 2rem;
    border-radius: 0.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card {
    border-radius: 0.75rem;
    border: none;
}
</style>
